export { Desktop, DEFAULT_ORDER_TYPES } from './Desktop';
export { Mobile } from './Mobile';
export { DEFAULT_FILTERS_STATE, filtersReducer, FILTER_ACTIONS } from './reducer';
